import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSelect,{attrs:{"outlined":"","items":_vm.items,"item-text":"text","item-value":"value","label":_vm.$t('Time Type'),"hide-details":"auto"},model:{value:(_vm.time),callback:function ($$v) {_vm.time=$$v},expression:"time"}})}
var staticRenderFns = []

export { render, staticRenderFns }